import { Component, OnInit } from '@angular/core';
import { BaseReportCardComponent } from '../base-report-card.component';
import { QuoteStatsViewModel, ReportGenSvc, ReportWithDatesRequest } from 'src/app/services_autogenerated/generated_services';
import { Chart } from 'chart.js';
import { RmDateRangeServiceService } from 'src/app/services/rm-date-range-service.service';

@Component({
    selector: 'app-quote-stats',
    templateUrl: './quote-stats.component.html',
    styleUrls: ['./quote-stats.component.css'],
    standalone: false
})
export class QuoteStatsComponent extends BaseReportCardComponent implements OnInit {
  options;
  statsLoading: boolean = true;
  quoteStats: QuoteStatsViewModel;

  constructor(private reportService: ReportGenSvc,
      private rmDashboardDateRangeService: RmDateRangeServiceService) {
    super();
  }

  ngOnInit() {
    this.rmDashboardDateRangeService.getDateRangeUpdater().subscribe(changed => {
      this.statsLoading = true;
      this.startDate = changed.start;
      this.endDate = changed.end;
      
      const titlePlugin = {
        id: 'title',
        afterDatasetsDraw: function (chart, args, plugins) {
          const {ctx, data} = chart;
          const xCenter = chart.getDatasetMeta(0).data[0]._view.x; 
          const yCenter = chart.getDatasetMeta(0).data[0]._view.y; 
          const innerRadius = chart.getDatasetMeta(0).data[0]._view.innerRadius;

          const color = plugins.color || 'black';
          const title = plugins.title || '';
          const datapoint = data.datasets[0].data[0] / (data.datasets[0].data[1] + data.datasets[0].data[0]) * 100;

          // % signed text
          ctx.font = `bold ${(innerRadius / 2 - 5)}px sans-serif`;
          ctx.fillStyle = color;
          ctx.textAlign = 'center';
          ctx.baseline = 'middle';
          
          ctx.fillText(`${datapoint.toFixed(1)}%`, xCenter, yCenter);

          // title text
          ctx.font = 'bold 20px sans-serif';
          ctx.fillStyle = 'rgb(35,35,35)';
          ctx.textAlign = 'center';
          ctx.baseline = 'middle';
          ctx.fillText(`${title}`, xCenter, yCenter + 20);
        }
      }

      this.reportService.getQuoteStats(new ReportWithDatesRequest({
        id: !this.companyWide ? this.employee.id : null,
        afterDate: this.startDate,
        beforeDate: this.endDate
      })).subscribe(res => {
        this.quoteStats = res;
        this.statsLoading = false;
        
        this.options = {
          type: 'doughnut',
          data: {
            datasets: [{
              data: [res.signed, (res.sent - res.signed) > 0 ? res.sent - res.signed : 1],
              backgroundColor: ["rgb(113,138,158)", "rgb(169,169,169)"]
            }]
          },
          options: {
            legend: {
              display: false
            },
            rotation: -1.0 * Math.PI, // start angle in degrees
            circumference: Math.PI, // sweep angle in degrees
            events: [],
            title: {
              display: false
            },
            layout: {
              padding: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 30
              }
            },
            plugins: {
              title: {
                color: 'rgb(113,138,158)',
                title: 'Percent Signed'
              }
            },
          },
          plugins: [titlePlugin],
        }

        var canvas = <HTMLCanvasElement>document.getElementById('chartJSContainer')
        var ctx = canvas.getContext('2d');
        new Chart(ctx, this.options);
      });
    });
  }
}
